export const getTeamTypes = () => {
  return {
    HOME_AND_AWAY: 1,
    HOME: 2,
    AWAY: 3,
  }
}
